import { render, staticRenderFns } from "./skuModulesV2.vue?vue&type=template&id=19bcbb86&scoped=true&"
import script from "./skuModulesV2.vue?vue&type=script&lang=js&"
export * from "./skuModulesV2.vue?vue&type=script&lang=js&"
import style0 from "./skuModulesV2.vue?vue&type=style&index=0&id=19bcbb86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bcbb86",
  null
  
)

export default component.exports